import React from "react";
import styled, { css } from "styled-components";
import { DEFAULT_DESCRIPTION_CONSTANT, Module } from "../../constants";
import { getHashCommitValue } from "../../utils/helpers/text";
import { useMobile } from "../../utils/hooks/useMobile";
import { changeDateFormat } from "../../utils/helpers/text";
import { generateID } from "@digitallab/grid-common-components";

const moduleVersionInfoMobile = css`
  font-size: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1rem;
  width: 90%;
  & > p {
    padding: 0;
    width: 100%;
  }
  & > p[data-testid$="text"] {
    padding: 0 0 5px 0;
    &: not(: last-child) {
      border-bottom: 1px solid #eee;
    }
  }
`;
const moduleVersionInfoTitleMobile = css`
  text-align: center;
  font-size: 14px;
  line-height: 14px;
  padding-bottom: 10px;
`;
export const ModuleVersionInfoStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr minmax(auto, 70%);
  width: 80%;
  max-width: 800px;
  & > p:first-child {
    grid-row: 1;
  }
  grid-gap: 10px;
  white-space: wrap;
  text-overflow: ellipsis;
  text-align: left;
  padding-left: 8px;
  font-weight: 400;
  text-transform: uppercase;
  font-size: 16px;
  line-height: 16px;
  align-items: flex-start;
  background: white;
  border-radius: var(--one-border-radius-4);
  padding: 15px;
  box-sizing: border-box;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  margin-bottom: 20px;
  & > p {
    margin: 0;
    padding: 8px;
  }
  & > a {
    text-decoration: none;
    color: #888;
    font-weight: 500;
    text-align: left;
    margin: 0;
    padding: 8px;
  }
  & > a > p {
    margin: 0;
  }

  & > p[data-testid$="text"] {
    font-weight: 500;
    text-align: left;
  }
  & > p.title {
    grid-row: 1;
    display: grid;
    grid-column: span 2;
    text-align: left;
    border-bottom: 1px solid #eee;
    font-size: 20px;
    line-height: 20px;
    padding-bottom: 15px;
    ${(props) => props.isMobile && moduleVersionInfoTitleMobile}
  }
  ${(props) => props.isMobile && moduleVersionInfoMobile}
`;

const DescriptionCard = ({
  title = "Information",
  moduleVersion = process.env.REACT_APP_MODULE_VERSION,
  moduleName = process.env.REACT_APP_MODULE_NAME,
  ciJobId = process.env.REACT_APP_CI_JOB_ID,
  commitHash = process.env.REACT_APP_COMMIT_HASH,
  updatedAt = process.env.REACT_APP_UPDATED_AT,
  id = "card"
}) => {
  const isMobile = useMobile();
  return (
    <ModuleVersionInfoStyled
      data-testid="info-page-container"
      isMobile={isMobile}
      id={generateID.UUID(Module.PAGE.INFO.description, id, "card")}
    >
      <p className="title" id={generateID.UUID(Module.PAGE.INFO.infoTitle, id, "p")}>
        {title}
      </p>
      <p data-testid="info-page-app-name-label" id={generateID.UUID(Module.PAGE.INFO.infoAppName, id, "p")}>
        App name:
      </p>
      <p data-testid="info-page-app-name-text" id={generateID.UUID(Module.PAGE.INFO.infoModuleName, id, "p")}>
        {moduleName ?? DEFAULT_DESCRIPTION_CONSTANT.moduleName}
      </p>
      <p data-testid="info-page-module-version-label" id={generateID.UUID(Module.PAGE.INFO.infoSystemVersion, id, "p")}>
        System version:
      </p>
      <p dat-testid="info-page-module-version-text" id={generateID.UUID(Module.PAGE.INFO.infoModuleVersion, id, "p")}>
        {moduleVersion ?? DEFAULT_DESCRIPTION_CONSTANT.moduleVersion}
      </p>
      <p data-testid="info-page-ci-job-label" id={generateID.UUID(Module.PAGE.INFO.infoCiJobId, id, "p")}>
        CI job id:
      </p>
      <a
        href={ciJobId}
        target="_blank"
        rel="noreferrer"
        id={generateID.UUID(Module.PAGE.INFO.infoCiJobIdText, id, "a")}
      >
        <p data-testid="info-page-ci-job-text" id={generateID.UUID(Module.PAGE.INFO.infoCiJobIdText, id, "p")}>
          {ciJobId ? getHashCommitValue(ciJobId) : DEFAULT_DESCRIPTION_CONSTANT.ciJobId}
        </p>
      </a>
      <p data-testid="info-page-commit-hash-label" id={generateID.UUID(Module.PAGE.INFO.infoCommitHash, id, "p")}>
        Commit hash:
      </p>
      <a
        href={commitHash}
        target="_blank"
        rel="noreferrer"
        id={generateID.UUID(Module.PAGE.INFO.infoCommitHashText, id, "a")}
      >
        <p data-testid="info-page-commit-hash-text" id={generateID.UUID(Module.PAGE.INFO.infoCommitHashText, id, "p")}>
          {commitHash ? getHashCommitValue(commitHash) : DEFAULT_DESCRIPTION_CONSTANT.commitHash}
        </p>
      </a>
      <p data-testid="info-page-update-at-label" id={generateID.UUID(Module.PAGE.INFO.infoUpdateAt, id, "p")}>
        Updated at:
      </p>
      <p data-testid="info-page-update-at-text" id={generateID.UUID(Module.PAGE.INFO.infoUpdateAtText, id, "p")}>
        {updatedAt ? changeDateFormat(updatedAt, "mm/dd/yyyy h:mm:ss") : DEFAULT_DESCRIPTION_CONSTANT.updatedAt}
      </p>
    </ModuleVersionInfoStyled>
  );
};

export default DescriptionCard;
